module.exports = __webpack_public_path__ + "resources/icon-error.e982bda37714b6cc.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/notice-bar/img/icon-error.png
// module id = 577
// module chunks = 0 1 2 3